<template>
  <BaseDialog
    class="help-center-dialog"
    :title="$t('helpCenter.Title')"
    :text="$t('helpCenter.Subtitle')"
    :width="'440px'"
    :text-align="'left'"
    @close="$emit('close')"
  >
    <div class="help-center-dialog__close" @click="$emit('close')"></div>
    <div class="help-center-dialog__guides">
      <a
        v-for="guide in guides"
        :key="guide.id"
        class="help-center-dialog__guide"
        :href="guide.url"
        target="_blank"
        rel="noopener noreferrer"
        @click="$emit('close')"
      >
        <img class="help-center-dialog__guide-icon" :src="guide.icon" alt=""/>
        <div class="help-center-dialog__guide-text">
          <span class="body-text--bold">{{ guide.title }}</span>
          <span class="caption">{{ guide.description }}</span>
        </div>
        <img
          class="help-center-dialog__guide-arrow"
          src="/img/renova-dashboard/icons/arrow-right--purple.svg"
          alt=""
        />
      </a>
    </div>
    <span class="help-center-dialog__hint caption">{{ $t('helpCenter.OpensInNewTab') }}</span>
  </BaseDialog>
</template>
<script>
import BaseDialog from '@/views/RenovaDashboard/components/ui-kit/BaseDialog';

const GUIDE_URLS = {
  en: {
    salesHub: 'https://renova.notion.site/Sales-Hub-Step-by-Step-Setup-Guide-35d10273ff20814e830fdf18029ff356',
    serviceHub: 'https://renova.notion.site/Service-Hub-Step-by-Step-Setup-Guide-35d10273ff2081969fe3c396bc2389f5',
  },
  es: {
    salesHub: 'https://app.notion.com/p/renova/Sales-Hub-Gu-a-paso-a-paso-ES-38a10273ff208102b692df38a8d6dc17',
    serviceHub: 'https://app.notion.com/p/renova/Service-Hub-Gu-a-paso-a-paso-ES-38a10273ff2081308257edbe944ceda8',
  },
};

export default {
  name: 'HelpCenterDialog',
  components: {
    BaseDialog,
  },
  emits: ['close'],
  computed: {
    guides() {
      const urls = GUIDE_URLS[this.$i18n.locale] || GUIDE_URLS.en;

      return [
        {
          id: 'salesHub',
          title: this.$t('onboarding.SalesHub'),
          description: this.$t('helpCenter.SalesHubDescription'),
          icon: '/img/renova-dashboard/menu/leads-black.svg',
          url: urls.salesHub,
        },
        {
          id: 'serviceHub',
          title: this.$t('onboarding.ServiceHub'),
          description: this.$t('helpCenter.ServiceHubDescription'),
          icon: '/img/renova-dashboard/menu/requests-black.svg',
          url: urls.serviceHub,
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.help-center-dialog ::v-deep .base-dialog {
  position: relative;
  padding: 24px;

  h3 {
    margin: 0 24px 4px 0;
  }

  p {
    margin-bottom: 20px;
  }
}

.help-center-dialog__close {
  position: absolute;
  top: 24px;
  right: 24px;
  width: 16px;
  height: 16px;
  cursor: pointer;
  opacity: 0.5;
  transition: 0.3s;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url(/public/img/renova-dashboard/icons/close-btn.svg);

  &:hover {
    opacity: 1;
  }
}

.help-center-dialog__guides {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.help-center-dialog__guide {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border: 1px solid var(--solid-lavender-grey);
  border-radius: 8px;
  text-decoration: none;
  cursor: pointer;
  transition: 0.3s;

  &:hover {
    border-color: var(--solid-purple);
    background: var(--solid-light-purple);

    .help-center-dialog__guide-arrow {
      transform: translateX(2px);
    }
  }
}

.help-center-dialog__guide-icon {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}

.help-center-dialog__guide-text {
  display: flex;
  flex-direction: column;
  gap: 2px;

  .body-text--bold {
    color: var(--solid-black-purple);
  }

  .caption {
    color: var(--solid-dark-purple);
  }
}

.help-center-dialog__guide-arrow {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  margin-left: auto;
  transition: 0.3s;
}

.help-center-dialog__hint {
  display: block;
  margin-top: 16px;
  color: var(--solid-dark-purple);
}

@media screen and (max-width: 668px) {
  .help-center-dialog ::v-deep .base-dialog {
    width: calc(100vw - 40px) !important;
    padding: 20px;
  }

  .help-center-dialog__close {
    top: 20px;
    right: 20px;
  }
}
</style>
